import { Block } from '../types';

const START = 6 * 60; // 6:00 am
const END = 22 * 60; // 10:00 pm
const BLOCK_LEN = 30;

export const TOTAL_BLOCKS = (END - START) / BLOCK_LEN; // 32

function fmt(h: number, mi: number): string {
  const hh = h > 12 ? h - 12 : h === 0 ? 12 : h;
  const ap = h >= 12 ? 'pm' : 'am';
  return `${hh}${mi === 0 ? ':00' : ':30'}${ap}`;
}

export function createBlocks(): Block[] {
  const blocks: Block[] = [];
  for (let m = START; m < END; m += BLOCK_LEN) {
    const h1 = Math.floor(m / 60);
    const mi1 = m % 60;
    blocks.push({
      id: m,
      label: fmt(h1, mi1),
      activity: '',
      status: null,
    });
  }
  return blocks;
}
